import React from "react";

import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";

import HorarioRangos from "../../rangos/HorarioRangos";

export default function RangoModal({
    horarioId, closeModal, service, onUpdate
}) {
    return (
        <>
            <HorarioRangos horarioId={horarioId} service={service} onUpdate={onUpdate} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>

        </>
    );
}